import { ApolloProvider } from "@apollo/client";
import { apolloClient, i18n, Provider, showMessage } from "./common";
import { setRateLimitHandler } from "./common/apiGraphql/rateLimitErrorLink";
import MainRouter from "./pages/_router/main.router";
import { HelmetProvider } from "react-helmet-async";

// A RATE_LIMITED / IP_BLOCKED denial from the API is toasted once here, for every
// mutation, instead of per call site. Wired from the entry rather than inside the link
// to avoid an import cycle through the `common` barrel.
setRateLimitHandler(() => {
  showMessage({
    type: 'error',
    message: i18n.t('common.messages.rateLimited'),
    duration: 8000,
    fixed: true
  });
});

const App = () => (
  <Provider>
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <MainRouter></MainRouter>
      </ApolloProvider>
    </HelmetProvider>
  </Provider>
);

export default App;
